export default __webpack_public_path__ + "static/media/bg_sphere.2a5aa8db.svg";